import { __rest } from 'tslib';
import React from 'react';
import { Box } from '../../grid/Box/styled.js';
import { Text } from '../../typography/Text/Text.js';
import { useTheme } from '../../theme/Theme.js';
import { Button } from '../Button/Button.js';
import { Root } from './styled.js';

const Drawer = (_a) => {
    var { fullscreen = false, description, placement = 'right', okButtonProps, onOk, okText = 'Принять', cancelButtonProps, onCancel, cancelText = 'Отмена', footer } = _a, props = __rest(_a, ["fullscreen", "description", "placement", "okButtonProps", "onOk", "okText", "cancelButtonProps", "onCancel", "cancelText", "footer"]);
    const theme = useTheme();
    const isVertical = placement === 'top' || placement === 'bottom';
    const isHorizontal = placement === 'left' || placement === 'right';
    const title = (() => {
        if (description)
            return (React.createElement(Box, { "$display": 'flex', "$flexDirection": 'column' },
                props.title,
                React.createElement(Text, { color: theme.colors.gray500, fontWeight: '400', size: 'small' }, description)));
        return props.title;
    })();
    const footerNode = React.useMemo(() => {
        var _a, _b;
        if (typeof footer === 'undefined') {
            return (React.createElement(Box, { "$width": '100%', "$display": 'inline-flex', "$alignItems": 'center', "$justifyContent": 'flex-end', "$gap": 8 },
                React.createElement(Button, Object.assign({ "data-testid": 'tend-ui-drawer-cancel-button', variant: 'secondary' }, cancelButtonProps, { onClick: (_a = cancelButtonProps === null || cancelButtonProps === void 0 ? void 0 : cancelButtonProps.onClick) !== null && _a !== void 0 ? _a : onCancel }), (cancelButtonProps === null || cancelButtonProps === void 0 ? void 0 : cancelButtonProps.children) || cancelText),
                React.createElement(Button, Object.assign({ "data-testid": 'tend-ui-drawer-ok-button' }, okButtonProps, { onClick: (_b = okButtonProps === null || okButtonProps === void 0 ? void 0 : okButtonProps.onClick) !== null && _b !== void 0 ? _b : onOk }), (okButtonProps === null || okButtonProps === void 0 ? void 0 : okButtonProps.children) || okText)));
        }
        return footer;
    }, [cancelButtonProps, cancelText, footer, okButtonProps, okText, onCancel, onOk]);
    const headerStyle = Object.assign(Object.assign({}, props.headerStyle), { borderBottom: 'none' });
    const bodyStyle = Object.assign(Object.assign({}, props.bodyStyle), { padding: '0 24px' });
    const footerStyle = Object.assign(Object.assign({}, props.footerStyle), { borderTop: 'none', padding: '16px 24px' });
    const contentWrapperStyle = {
        top: Object.assign(Object.assign({}, props.contentWrapperStyle), { overflow: 'hidden', borderRadius: '0 0 16px 16px' }),
        right: Object.assign(Object.assign({}, props.contentWrapperStyle), { overflow: 'hidden', borderRadius: '16px 0 0 16px' }),
        bottom: Object.assign(Object.assign({}, props.contentWrapperStyle), { overflow: 'hidden', borderRadius: '16px 16px 0 0' }),
        left: Object.assign(Object.assign({}, props.contentWrapperStyle), { overflow: 'hidden', borderRadius: '0 16px 16px 0' }),
    }[placement];
    const width = (() => {
        if (fullscreen && isHorizontal)
            return '100%';
        return props.width;
    })();
    const height = (() => {
        if (fullscreen && isVertical)
            return '100%';
        return props.height;
    })();
    return (React.createElement(Root, Object.assign({ "data-testid": 'tend-ui-drawer' }, props, { "$theme": theme, headerStyle: headerStyle, bodyStyle: bodyStyle, footerStyle: footerStyle, contentWrapperStyle: contentWrapperStyle, title: title, footer: footerNode, placement: placement, width: width, height: height })));
};
Drawer.displayName = 'Drawer';

export { Drawer };
//# sourceMappingURL=Drawer.js.map
